import LinkButton from 'components/LinkButton/LinkButton';

export default LinkButton;
